import ENV from '@/env.json'

function setAuthForm(token: string) {
  return new Promise((resolve, reject) => {
    fetch(`${ENV.VERIFICATION__API_URL}/v1/show_auth_form`, {
      method: 'PUT',
      body: JSON.stringify({ show_auth_form: false }),
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then(async (resp) => {
        if (!resp.ok) {
          const error = await resp.clone().json()
          reject(error)
        }
        return true
      })
      .then((data) => {
        resolve(data)
      })
  })
}

function sendMail(
  token: string,
  email: string,
  redirectUri: string,
): { type?: string; message?: string; [key: string]: any } {
  return new Promise((resolve, reject) => {
    fetch(`${ENV.VERIFICATION__API_URL}/v1/email/send_link`, {
      method: 'POST',
      body: JSON.stringify({ email: email, redirect_uri: redirectUri }),
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then(async (resp) => {
        if (!resp.ok) {
          const error = await resp.clone().json()
          reject(error)
        }
        return resp.json()
      })
      .then((data) => {
        resolve(data)
      })
  })
}

function confirmEmail(token: string) {
  return new Promise((resolve, reject) => {
    fetch(`${ENV.VERIFICATION__API_URL}/v1/email/verify/${token}`, {
      method: 'POST',
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then(async (resp) => {
        if (!resp.ok) {
          reject(resp)
        }
        return resp.json()
      })
      .then((data) => {
        resolve(data)
      })
  })
}

function verifyPhoneByCode(
  uuid: string,
  code: string,
  token: string,
): { type?: string; message?: string; [key: string]: any } {
  return new Promise((resolve, reject) => {
    fetch(`${ENV.VERIFICATION__API_URL}/v1/phone/verify`, {
      method: 'POST',
      body: JSON.stringify({ id: uuid, code: code }),
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then(async (resp) => {
        if (!resp.ok) {
          const error = await resp.clone().json()
          reject({ ...error, code: resp.status })
        }
        return resp.json()
      })
      .then((data) => {
        resolve(data)
      })
  })
}

function sendCode(phone: string, token: string) {
  return new Promise((resolve, reject) => {
    fetch(`${ENV.VERIFICATION__API_URL}/v1/phone/send_code`, {
      method: 'POST',
      body: JSON.stringify({ phone }),
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then(async (resp) => {
        if (!resp.ok) {
          const error = await resp.clone().json()
          reject(error)
        }
        return resp.json()
      })
      .then((data) => {
        resolve(data)
      })
  })
}

export { setAuthForm, sendMail, confirmEmail, verifyPhoneByCode, sendCode }
